import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { LightGradient } from "./LightGradient";
export var LightArea = /*#__PURE__*/function () {
  function LightArea() {
    _classCallCheck(this, LightArea);
    this.gradient = new LightGradient();
    this.radius = 1000;
  }
  _createClass(LightArea, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      this.gradient.load(data.gradient);
      if (data.radius !== undefined) {
        this.radius = data.radius;
      }
    }
  }]);
  return LightArea;
}();